module.exports = {"white":"Blanc","black":"Noir","yellow":"Jaune"}